module.exports = __webpack_public_path__ + "static/media/dashboard-analytics.d3b855fe.png";